module.exports = __webpack_public_path__ + "static/media/4.ed23bb6c.jpg";